import { Title } from "../components/Title";

import { Box, Tab, Tabs } from "@mui/material";
import { JumbotronOverlay } from "../components/JumbotronOverlay";
import { Footer } from "../components/Footer";
import { useState } from "react";
import InfoIcon from "@mui/icons-material/Info";
import GasMeterIcon from "@mui/icons-material/GasMeter";
import legal from "../assets/legal.jpg";
import GavelIcon from "@mui/icons-material/Gavel";
import PortraitIcon from "@mui/icons-material/Portrait";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { InformatiiGenerale } from "../components/InformatiiGenerale";
import { Contractare } from "../components/Contractare";
import { ContOnline } from "../components/ContOnline";
import { FacturaIntrebariFrecvente } from "../components/FacturaIntrebariFrecvente";
import { IndexIntrebariFrecvente } from "../components/IndexIntrebariFrecvente";
import { JumbotronTitle } from "../components/JumbotronTitle";

export const IntrebariFrecventePage: React.FC = () => {
  const [value, setValue] = useState<number>(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        overflowX: "hidden",
      }}
    >
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "white",
        }}
      >
        <Title role={null} />
      </Box>
      <Box
        className="jumbotron-container"
        sx={{
          width: "100%",
          minHeight: "711px",
          overflow: "hidden", // Prevent horizontal scrollbar
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={legal}
          alt="jumbotron"
          style={{
            width: "100%", // Maintain aspect ratio and cover the container
            height: "100%",
            objectFit: "cover",
            position: "absolute", // Ensure images are absolutely positioned
            top: 0, // Position images at the top
            left: 0, // Position images at the left
            animation: "zoom-in 20s ease-in-out",
            flexShrink: 0,
          }}
          draggable="false"
          unselectable="on"
        />
        <JumbotronOverlay page={0} specialOverlay={false} />
        <JumbotronTitle title="Întrebari Frecvente" />
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "70px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderBottom: "0.2px solid black",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="icon label tabs example"
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          selectionFollowsFocus
          sx={{
            mb: "5px",
          }}
        >
          <Tab
            icon={<GavelIcon />}
            label="Contractare"
            sx={{ fontFamily: "Catesque" }}
          />
          <Tab
            icon={<PortraitIcon />}
            label="Cont Online"
            sx={{ fontFamily: "Catesque" }}
          />
          <Tab
            icon={<GasMeterIcon />}
            label="Index"
            sx={{ fontFamily: "Catesque" }}
          />
          <Tab
            icon={<FileCopyIcon />}
            label="Factura"
            sx={{ fontFamily: "Catesque" }}
          />
          <Tab
            icon={<InfoIcon />}
            label="Informații Generale"
            sx={{ fontFamily: "Catesque" }}
          />
        </Tabs>
      </Box>
      {value === 0 && <Contractare />}
      {value === 1 && <ContOnline />}
      {value === 2 && <IndexIntrebariFrecvente />}
      {value === 3 && <FacturaIntrebariFrecvente />}
      {value === 4 && <InformatiiGenerale />}
      <Footer />
    </Box>
  );
};
